import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { SvgIcon } from 'core/icons';
import Raw from '../../common/Raw';
import { useNotifications } from '../../common/notifications/NotificationsContext';

class Notification extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  onScroll = () => {
    this.props.onClose();
  };

  onBodyClick = event => {
    const isTargetNotification = $.contains(this.ref.current, event.target);
    if (!isTargetNotification) {
      this.props.onClose();
    }
  };

  componentDidMount() {
    setTimeout(() => {
      const isFullScreen = this.ref.current.clientHeight >= window.innerHeight;
      if (isFullScreen) {
        document.body.style.overflow = 'hidden';
      } else {
        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('click', this.onBodyClick);
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('click', this.onBodyClick);
    document.body.style.overflow = '';
  }

  render() {
    const { message, onClose } = this.props;

    return (
      <div className="notifications__container" ref={this.ref}>
        <div className="notifications">
          <div className="notifications__header">
            <SvgIcon
              name="close"
              className="notifications__close stat-button-close"
              data-dtm="disclosure"
              onClick={onClose}
            />
          </div>
          <div className="notifications__inner" data-role="scroll">
            <Raw as="div" value={message} className="notifications__content" />
          </div>
        </div>
      </div>
    );
  }
}

const Notifications = () => {
  const { message, visible, dismiss } = useNotifications();
  const container = useRef(document.createElement('div'));
  useEffect(() => {
    document.body.appendChild(container.current);
    return () => {
      document.body.removeChild(container.current);
    };
  }, []);

  if (visible) {
    return ReactDOM.createPortal(
      <Notification message={message} onClose={dismiss} />,
      container.current
    );
  }

  return null;
};

export default Notifications;
